/**
 * Device Assignment の「アラート」「ルールとポリシー」画面の公開制御 FeatureFlag。
 *
 * OFF の間は両画面ともに ComingSoonCover（プレースホルダー）を表示し、
 * 実装済みの一覧・詳細・作成フローへは遷移できない。ON にすると本実装を公開する。
 * 2 画面は常にセットで公開/非公開するため、フラグは 1 つで管理する。
 *
 * NOTE: キー名は BE と共有する SNAKE_CASE。BE 側 FEATURE_FLAG_DEFINITIONS と一致させる。
 * 既定は prd のみ OFF（本番非公開）を想定。
 */
export const DEVICE_ASSIGNMENT_FEATURE_FLAG = 'DEVICE_ASSIGNMENT_ALERT_AND_RULE';